module.exports = __webpack_public_path__ + "img/rocket-loader.1df30e07.gif";